(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const groups = [
    '.banzrc-gt-performance-overview__header, .banzrc-gt-performance-overview__fact',
    '.banzrc-gt-road-story__content',
    '.banzrc-gt-power-guide__header, .banzrc-gt-power-guide__context, .banzrc-gt-power-guide__system, .banzrc-gt-power-guide__battery',
    '.banzrc-gt-identity__inner',
    '.banzrc-gt-chassis__heading, .banzrc-gt-chassis__figure, .banzrc-gt-chassis__copy',
    '.banzrc-gt-engineering__figure, .banzrc-gt-engineering__copy',
    '.banzrc-gt-specs__header, .banzrc-gt-specs__group',
    '.banzrc-gt-ready__intro, .banzrc-gt-ready__included, .banzrc-gt-ready__required, .banzrc-gt-ready__optional',
    '.banzrc-gt-ownership__header, .banzrc-gt-ownership__chapter',
    '.banzrc-gt-finale__content, .banzrc-gt-finale__finishes'
  ];
  const targets = [...new Set(groups.flatMap((selector) => [...document.querySelectorAll(selector)]))];
  if (!targets.length) return;

  document.documentElement.classList.add('banzrc-gt-motion-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });

  const counters = new Map();
  targets.forEach((element) => {
    const section = element.closest('.shopify-section') || document.body;
    const index = counters.get(section) || 0;
    counters.set(section, index + 1);
    element.classList.add('banzrc-gt-motion-reveal');
    element.style.setProperty('--banzrc-motion-delay', `${Math.min(index, 4) * 72}ms`);
    if (element.getBoundingClientRect().top < window.innerHeight * .88) {
      element.classList.add('is-visible');
    } else {
      observer.observe(element);
    }
  });
})();
